export default class ErrorNotification {
    constructor(element, message) {
        this.element = element;
        this.message = message;
    }

    init() {
        const errorHtml = `${'<div class="alert alert-danger alert-dismissible '
            + 'fade show" role="alert">'
            + '<button type="button" class="close" data-dismiss="alert" aria-label="Close">'
            + '<span aria-hidden="true">&times;</span>'
            + '</button>'}${this.message}</div>`;

        $(this.element).append(errorHtml);
    }
}
